<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      药品信息
    </div>
    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li class="result-item" v-for="(item, index) in recordList" :key="index">
          <div class="item-name">药品名称：{{item.name}}</div>
          <div class="item-number">库存数量：{{item.qty}}</div>
          <div class="item-number">药剂浓度：{{item.concentration}}</div>
          <div class="item-number" v-if="item.validityUnit === 0">有效期：{{item.validity}} 长期有效</div>
          <div class="item-number" v-if="item.validityUnit === 1">有效期：{{item.validity}} 年</div>
          <div class="item-number" v-if="item.validityUnit === 2">有效期：{{item.validity}} 月</div>
          <div class="item-number" v-if="item.validityUnit === 3">有效期：{{item.validity}} 日</div>
          <div class="item-number" v-if="item.validityUnit === 4">有效期：{{item.validity}} 时</div>
          <div class="item-btn">
            <el-button class="btn" @click="check(item.id, item.name)">查看</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import BScroll from 'better-scroll'

export default {
    data() {
        return {
            popstateLock: 0,//是否监听物理返回键
            loading: false,
            page: 1, // 分页查询，第一次为1
            pullupMsg: '加载更多',
            isShowTips: false,
            recordList:[],
        };
    },
    created() {
        this.searchRecord();
    },
    watch: {
        popstateLock(val) {
            //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
            if (val) {
                this.addPopstate()
            } else {
                this.removePopstate()
            }
        }
    },
    destroyed() {
        this.removePopstate()
    },
    methods: {
        addPopstate() {
            //判断是否H5路由
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                history.pushState(null, null, document.URL);
                // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
                window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
            }
        },
        removePopstate() {
            //解除监听
            window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
        },
        //指挥路由
        getBack() {
            //判断物理返回键是否监听
            if (!this.popstateLock) {
                window.history.pushState(null, null, '#')
            }
        },
        // 返回上一层
        backIndex() {
            this.$router.push({name: 'medicineMessageRecord'})
        },
        //查看
        check(id, name) {
            let getMedicineId = this.$route.query.medicineId;
            this.$router.push({name: 'medicineDetail', query: {id: id, medicineId: getMedicineId, name: name, isCreate: false}})
        },
        //新增
        create() {
            this.$router.push({name: 'medicineDetailEdit', query: {isCreate: true}})
        },
        scanCode() {
            // 获取jsapi_ticket
            this.$http
                .get("/wechat/sign/url", {
                    params: {
                        // 这里是当前页面的url（本页面的域名必须与公众号js安全域名一致），一定要 location.href 获取，不然签名会无效。
                        url: location.href
                    }
                })
                .then(function (res) {
                    // 通过config接口注入权限验证配置
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.appId, // 必填，公众号的唯一标识
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.signature, // 必填，签名
                        jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
                    });

                    //通过ready接口处理成功验证
                    wx.ready(function () {
                        // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
                        // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
                        wx.checkJsApi({
                            // 判断当前客户端版本是否支持指定JS接口
                            jsApiList: ["scanQRCode"],
                            success: function (res) {
                                // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                                if (res.checkResult.scanQRCode === true) {
                                    wx.scanQRCode({
                                        // 微信扫一扫接口
                                        desc: "扫描设备二维码",
                                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                                        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                                        success: function (res) {
                                            let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                                            window.location.href = scanResult;
                                        }
                                    });
                                } else {
                                    alert("抱歉，当前客户端版本不支持扫一扫");
                                }
                            },
                            fail: function (res) {
                                // 检测getNetworkType该功能失败时处理
                                alert("检测失败" + res);
                            }
                        });
                    });
                })
                .catch(function (error) {
                    alert("扫码失败" + error);
                });
        },
        searchRecord() {
            this.page = 1;
            let getMedicineId = this.$route.query.medicineId;
            this.$http.httpGet('/app/laMedicineDetail/detailList/' + getMedicineId, {
                medicineId: getMedicineId,
            }).then(res => {
                if (res.code === 0 && res.msg === 'success') {
                    if (res.detailList.length == 0) {
                        this.$message.info('查无记录')
                    }
                    this.recordList = res.detailList
                    this.page++
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        _initBScroll() {
            if (!this.scroll) {
                this.scroll = new BScroll(this.$refs.wrapper, {
                    //开启点击事件 默认为false
                    click: true,
                    scrollY: true,
                    probeType: 3
                })
                // 一些监听
                this.scroll.on('scroll', (pos) => {
                    if (pos.y - this.scroll.maxScrollY < -50) {
                        this.isShowTips = true
                    } else {
                        this.isShowTips = false
                    }
                })

                this.scroll.on('touchEnd', pos => {
                    // 1.2.1监听下拉
                    if (pos.y >= 50) {
                        console.log('下拉刷新')
                    }
                    // 1.2.2监听上拉
                    if (this.scroll.maxScrollY > pos.y + 50) {
                        this.loading = true
                        let getMedicineId = this.$route.query.medicineId;
                        this.$http.httpGet('/app/laMedicineDetail/detailList/' + getMedicineId, {
                            medicineId: getMedicineId,
                        }).then(res => {
                            this.loading = false
                            if (res.code === 0 && res.msg === 'success') {
                                if (res.detailList.length == 0) {
                                    this.$message.info('没有更多数据了')
                                    return
                                }
                                this.page++
                                let arr = res.detailList
                                this.recordList = this.recordList.concat(arr)
                                this.$nextTick(() => {
                                    this.scroll.refresh()
                                    this.scroll.finishPullUp()
                                })
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }
                })
            } else if (!this.$refs.wrapper) {
                return
            } else {
                this.scroll.refresh()
            }
        },
    },
    mounted() {
        this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
        this.$nextTick(() => {
            this._initBScroll()
        })
    }
}
</script>

<style scoped lang="scss">
    //@import '@/assets/style/global.scss';
    .record-search {
        margin: 0;
        padding: 50px 0 0;
        position: relative;
        width: 100%;

        .headLine {
            height: 50px;
            position: fixed;
            overflow: hidden;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            color: #000;
            font-weight: 600;
            text-align: center;
            line-height: 50px;
            z-index: 9;
            font-size: 16px;
            border-bottom: 1px #efefef solid;

            img {
                height: 30px;
                margin: 10px 0;
                padding: 0 10px;
                position: absolute;
                left: 0;
                top: 0;
            }
        }

        .search-input {
            position: relative;
            margin: 0 0 20px;
            overflow: hidden;

            .search-wrapper {
                position: relative;
                padding: 15px 20px;

                .wrapper-input {
                    box-sizing: border-box;
                    width: calc(100% - 5rem);
                    height: 4rem;
                    line-height: 4rem;
                    border-radius: 6px 0 0 6px;
                    border: 1px solid #ddd;
                    background-color: #fff;
                    // display: inline-block;
                    float: left;

                    input {
                        height: 3rem;
                        width: calc(100% - 2rem);
                        border: none;
                        padding: 0.5rem 1rem;
                        font-size: 1.6rem;
                        outline-style: none;
                        color: #333;
                        background-color: transparent;
                    }
                }

                .wrapper-icon {
                    position: relative;
                    background-color: rgba(245, 209, 7, 0.801);
                    width: 5rem;
                    height: 4rem;
                    display: inline-block;
                    line-height: 4rem;
                    text-align: center;
                    border-radius: 0 6px 6px 0;

                    a {
                        color: #333;

                        i {
                            font-size: 3rem;
                            font-weight: bold;
                        }
                    }
                }
            }

            .search-select {
                display: flex;
                justify-content: space-between;
                text-align: center;
                padding: 0 20px 10px;

                .el-select {
                    width: 100%;
                }
            }

            .search-btn {
                margin-top: 0;
                padding: 0 20px;

                button {
                    height: 3.2rem;
                    font-weight: 700;
                    display: inline-block;
                    width: 40%;
                }

                .btn-left {
                    float: left;
                    width: 48%;
                    background-color: rgb(207, 0, 0);
                }

                .btn-right {
                    float: right;
                    width: 48%;
                    background-color: rgb(6, 175, 6);
                }
            }
        }

        .search-result {
            position: relative;
            padding: 0;
            height: calc(100vh - 50px - 10px);
            width: 100%;
            // height: 100%;
            overflow: hidden;

            .result-content {
                padding: 10px 20px 10px;

                .result-item {
                    position: relative;
                    box-sizing: border-box;
                    padding: 10px 10px 10px;
                    border-radius: 0.5rem;
                    margin-top: 1.6rem;
                    /*height: 12rem;*/
                    background-color: #f2f6fc;
                    color: #303133;
                    font-size: 1.6rem;
                    box-shadow: 0 0.3rem 0.5rem #eee;

                    .item-name,
                    .item-number{
                        position: relative;
                        margin-bottom: 5px;
                        height: 2rem;
                        text-align: left;
                        line-height: 2rem;
                        font-size: 1.4rem;
                        color: #000;
                    }

                    .item-btn {
                        position: relative;
                        margin-bottom: 25px;
                        height: 2rem;
                        line-height: 2rem;
                        font-size: 1.4rem;
                        color: #000;

                        button {
                            height: 3.2rem;
                            font-weight: 700;
                            display: inline-block;
                            width: 98%;
                            background-color: #3A9DF2;
                        }
                    }
                }
            }
        }

        .warehouse-confirm {
            position: fixed;
            left: 0px;
            bottom: 0px;
            text-align: center;
            width: 100%;
            background-color: #fff;
            z-index: 99;
            border-top: 1px #efefef solid;

            button {
                width: 80%;
                height: 4rem;
                margin: 10px 0;
                background-color: #67c23a;
                font-size: 1.6rem;
                font-weight: bold;

                &:hover,
                &:active {
                    color: #fff;
                }
            }
        }

        .loading {
            position: fixed;
            bottom: 3rem;
            left: 45%;

            span {
                font-size: 1.4rem;
            }
        }

        .bottom-tip {
            width: 100%;
            height: 35px;
            line-height: 35px;
            text-align: center;
            color: #333;
            // background: #f2f2f2;
            position: absolute;
            bottom: -5px;
            font-size: 1.6rem;
            left: 0;
        }
    }

    ::v-deep .el-input__inner::-webkit-input-placeholder {
        color: #666;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .el-select-dropdown__item {
        font-size: 14px !important;
        line-height: 34px;
        padding: 0 20px;
    }
</style>
